var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8.389 1.276l4.255 2.451a2.117 2.117 0 011.05 1.821v1.57l.017.014v1.753l-.017.013v1.553c0 .753-.402 1.454-1.05 1.822l-4.255 2.451a2.14 2.14 0 01-2.102 0l-4.236-2.451A2.096 2.096 0 011 10.45V5.548c0-.753.403-1.453 1.05-1.82l4.237-2.452a2.14 2.14 0 012.102 0z",
    fill: "#fff",
    stroke: "#A8A8A8"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC44IiBkPSJNOC4zODg1OSAxLjI3NThMMTIuNjQzNyAzLjcyNzMyQzEzLjI5MTcgNC4xMTI1NiAxMy42OTQ0IDQuNzk1NDkgMTMuNjk0NCA1LjU0ODQ3VjcuMTE4MDdMMTMuNzExMyA3LjEzMjE0VjguODg1NDJMMTMuNjk0NCA4Ljg5ODA5VjEwLjQ1MTVDMTMuNjk0NCAxMS4yMDQ1IDEzLjI5MTcgMTEuOTA0OSAxMi42NDM3IDEyLjI3MjdMOC4zODg1OSAxNC43MjQyQzcuNzQwNjkgMTUuMDkxOSA2LjkzNTE4IDE1LjA5MTkgNi4yODcyOCAxNC43MjQyTDIuMDUwNjUgMTIuMjcyN0MxLjQwMjc1IDExLjkwNDkgMSAxMS4yMDQ1IDEgMTAuNDUxNVY1LjU0ODQ2QzEgNC43OTU0OSAxLjQwMjc1IDQuMDk1MDUgMi4wNTA2NSAzLjcyNzMyTDYuMjg3MjggMS4yNzU4QzYuOTM1MTggMC45MDgwNjggNy43NDA2OSAwLjkwODA2OCA4LjM4ODU5IDEuMjc1OFoiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNBOEE4QTgiLz4KPC9zdmc+Cg==";
export { SvgHexagon as ReactComponent };